// extracted by mini-css-extract-plugin
export var list = "trening-switcher-module--list--09823";
export var listActiveItem = "trening-switcher-module--list-active-item--58503";
export var listItem = "trening-switcher-module--list-item--a79b0";
export var scaling = "trening-switcher-module--scaling--74e09";
export var underLine = "trening-switcher-module--under-line--1ec76";